export type CancellationReasonType = '단순 변심' | '취소 후 재예약' | '여행 일정 취소' | '타 사이트 이용' | string;

export const cancellationReasons: CancellationReasonType[] = ['단순 변심', '취소 후 재예약', '여행 일정 취소', '타 사이트 이용', '기타'];
